import React, { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Carts from "../../../images/total_cart.svg";
import Oven from "../../../images/oven_green.svg";
import CoolingRoom from "../../../images/cooling_room_orange.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import CookingModal from "./CookingModal";
import { useSearchOvenDataQuery } from "./cookingApi";
import Button from "../../../components/shared/buttons/button";
import { useGetProcessingOvenSummaryQuery } from "../dashboard/processingApi";
import ProcessingOverviewModal from "../ProcessingOverviewModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate, getCurrentDateTime, getTranslatedOvenName, makeLotNumber, makeShiftWiseLotNumber } from "../../../helpers/Utils";
import { DEFAULT_DATETIME_FORMAT, DEFAULT_TIME_FORMAT, PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import moment from "moment-timezone";
import Box from "../../../images/boxes.svg";


const Cooking = () => {
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [ovenPage, setOvenPage] = useState(1);  
  // Individual state for each filter field
  const [filter, setFilter] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({  type: "", status: "" });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };


  const currentDate = getCurrentDate('YYYY-MM-DD');
  const [date, setDate] = useState(currentDate);
  const [lot] = useState(makeShiftWiseLotNumber(date));
  const [summaryLot, setSummaryLot] = useState(makeShiftWiseLotNumber(date));

 
  
  const { _t } = useTranslator();

  const [tab, setTab] = useState("cooking");
  const { data: summaryData, refetch: refetchSummary } = useGetProcessingOvenSummaryQuery({
    tab,
    oven_batch_code: summaryLot,
    data_from: "processing",
  });

  const { data: ovenData, refetch: refetchOvenData ,isLoading : isOvenDataLoading , isFetching :isOvenDataFetching } = useSearchOvenDataQuery({
    data_from: "processing",
    page:ovenPage,
    ...filter,
  });

  // Refetch data when filter changes
  useEffect(() => {
    refetchOvenData();
  }, [filter, refetchOvenData]);

  //  Oven Pagination 

  const handleOvenDataPageChange = (page) => {
    setOvenPage(page);
  };
  
  const { data: reworkOvenData ,isLoading : isReworkDataLoading , isFetching :isReworkDataFetching } = useSearchOvenDataQuery({
    data_from: "rework",
  });

  // Apply Filter on date selector change - Only refetch summary data
  
  useEffect(() => {
    const updatedBatchCode = makeShiftWiseLotNumber(date);
    setSummaryLot(updatedBatchCode);
  },[date]);


  const calculateDuration = (start, end) => {
    const startDate = moment(start);
    const endDate = moment(end);

    const diffMs = endDate.diff(startDate);

    // Convert milliseconds to total minutes
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    // Convert to hours and minutes
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    return `${hours} h ${minutes} min`;
  };

  const listItems = [
    {
      label: _t("processing.totalCartsOnFloor", "Total Carts on floor"),
      value: summaryData?.data.total_carts_on_floor,
      icon: Carts,
      showDay:false
    },
    {
      label: _t("processing.totalCartsInOven", "Total Carts in Oven"),
      value: summaryData?.data.total_carts_in_ovens,
      icon: Oven,
      showDay:false
    },
    {
      label: _t("processing.cartsInCoolingRoom", "Carts in Cooling Room"),
      value: summaryData?.data.total_carts_in_cooling_room,
      icon: CoolingRoom,
      showDay:false
    },
    {
      label: _t("processing.reworkCartsInOven", "Rework Carts in Oven"),
      value: summaryData?.data.total_ovens_carts_in_rework,
      icon: Oven,
      showDay:false
    },
    // Add On Trays
    {
      label: _t("total_tray", "Total Tray"),
      value: summaryData?.data?.total_tray || 0,
      icon: Box,
    },
    {
      label: _t("total_cheeks_tray", "Total Cheeks Tray"),
      value: summaryData?.data?.total_cheeks_tray || 0,
      icon: Box,
    },
    {
      label: _t("total_tapita_tray", "Total Tapita Tray"),
      value: summaryData?.data?.total_tapita_tray || 0,
      icon: Box,
    },
    {
      label: _t("total_strip_tray", "Total Strip Tray"),
      value: summaryData?.data?.total_strip_tray || 0,
      icon: Box,
    },
  ];
  const ovenColumns = [
    {
      label: _t("date", "Date"),
      accessor: "date_time_entered",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("batch_code", "Batch Code"),
      accessor: "oven_batch_code",
      cell: ({ value }) => {
        return `#${value}`;
      },
    },
    {
      label: _t("ovenNumber", "Oven Number"),
      accessor: "oven",
      cell: ({ value }) => {
        return getTranslatedOvenName(value.name , _t);
      },
    },
    {
      label: _t("time", "Time"),
      accessor: "time_entered",
      cell: ({ value }) => {
        if (!value) return ""; // Handle empty values gracefully
        return convertToUserTimezone(value, DEFAULT_TIME_FORMAT);
      },
    },
    {
      label: _t("cartNumber", "Carts Number"),
      accessor: "cart_number",
      cell: ({ value }) => {
        return value.name;
      },
    },
    {
      label: _t("type", "Type"),
      accessor: "type",
      cell: ({ value }) => {
        return _t(value,value);
      },
    },
    {
      label: _t("treysCount", "Treys Count"),
      accessor: "treys_count",
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ row }) => {
        const { status, time_end } = row;
        const isOvenDone = status === "cooking" && time_end &&
              convertToUserTimezone(time_end, null, undefined, "valueOf") < convertToUserTimezone(null, null, undefined, "valueOf");
        
        return (
          <span className={
            isOvenDone ? "cmn_badge done"
            : status === "cart_unloaded" ? "cmn_badge done"
            : status === "cooling_room" ? "cmn_badge"
            : status === "cooking" ? "cmn_badge inactive"
            : "cmn_badge rejected"
          }>
            {isOvenDone ? _t("ovenDone", "Oven Done!")
              : status === "cooling_room" ? _t("coolingRoom", "Cooling Room")
              : status === "cooking" ? _t("cooking", "Cooking")
              : status === "cart_unloaded" ? _t("cart_unloaded", "Cart Unloaded")
              : _t("bagged", "Bagged")}
          </span>
        );
      },
    },
    {
      label: _t("ovenDuration", "Oven Duration"),
      accessor: "duration",
      cell: ({ row }) => calculateDuration(row.time_entered, row.time_end),
    },
    {
      label: _t("timeEnd", "Time End"),
      accessor: "time_end",
      cell: ({ value }) => {
        if (!value) return ""; // Handle empty values gracefully
        return convertToUserTimezone(value, DEFAULT_DATETIME_FORMAT);
      },
    },
    {
      label: _t("overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          <Button
            size="small"
            label={
              row.status === "cart_unloaded" ? _t("view", "View") : _t("edit", "Edit")
            }
            className={row.status === "cart_unloaded" ? "borderRedBtn" : ""}
            onClick={
              row.status === "bagged"
                ? () => handleView(row)
                : () => handleEdit(row)
            }
          />
        </>
      ),
    },
  ];
  const reworkOvenColumns = [
    {
      label: _t("date", "Date"),
      accessor: "date_time_entered",
      cell: ({ value }) => {        
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("ovenNumber", "Oven Number"),
      accessor: "oven",
      cell: ({ value }) => {
        return getTranslatedOvenName(value.name , _t);
      },
    },
    {
      label: _t("time", "Time"),
      accessor: "time_entered",
      cell: ({ value }) => {
        if (!value) return ""; // Handle empty values gracefully        
        return convertToUserTimezone(value,DEFAULT_TIME_FORMAT);
      },
    },
    {
      label: _t("cartNumber", "Carts Number"),
      accessor: "cart_number",
      cell: ({ value }) => {
        return value.name;
      },
    },
    {
      label: _t("type", "Type"),
      accessor: "type",
      cell: ({ value }) => {
        return _t(value,value);
      },
    },
    {
      label: _t("treysCount", "Treys Count"),
      accessor: "treys_count",
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ row }) => {
        const { status, time_end } = row;

        const currentTime = new Date().getTime();

        const isOvenDone =
          status === "cooking" &&
          time_end &&
          new Date(time_end).getTime() < currentTime;

        return (
          <span
            className={
              isOvenDone
                ? "cmn_badge done"
                : status === "cooling_room"
                ? "cmn_badge"
                : status === "cooking"
                ? "cmn_badge inactive"
                : "cmn_badge rejected"
            }
          >
            {isOvenDone
              ? _t("ovenDone", "Oven Done!")
              : status === "cooling_room"
              ? _t("coolingRoom", "Cooling Room")
              : status === "cooking"
              ? _t("cooking", "Cooking")
              : _t("bagged", "Bagged")}
          </span>
        );
      },
    },

    {
      label: _t("fruit_weight", "Fruit Wt"),
      accessor: "cart_weight",
      cell: ({ row }) => {
        const { type, cart_weight, cheeks_cart_weight, strips_cart_weight } =
          row;

        const formatWeight = (weight) =>
          parseFloat(weight) === 0.0 ? _t("noData", "No data yet") : weight;

        if (type === "cheeks")
          return formatWeight(
            cheeks_cart_weight ?? _t("noData", "No data yet")
          );
        if (type === "strips")
          return formatWeight(
            strips_cart_weight ?? _t("noData", "No data yet")
          );
        if (type === "cheeks/strips") {
          const cheeksWeight = formatWeight(cheeks_cart_weight ?? "0");
          const stripsWeight = formatWeight(strips_cart_weight ?? "0");
          return `${cheeksWeight}/${stripsWeight}`;
        }

        return formatWeight(cart_weight ?? _t("noData", "No data yet"));
      },
    },

    {
      label: _t("ovenDuration", "Oven Duration"),
      accessor: "duration",
      cell: ({ row }) => calculateDuration(row.time_entered, row.time_end),
    },
    {
      label: _t("timeEnd", "Time End"),
      accessor: "time_end",
      cell: ({ value }) => {
        if (!value) return "";
        return convertToUserTimezone(value, DEFAULT_DATETIME_FORMAT);
      },
    },
  ];

  const handleAddOvenData = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };
  const handleEdit = (data) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };
  const handleView = (data) => {
    setSelectedRecord(data);
    setShowOverviewModal(true);
  };

  return (
    <div>
      {addRecord && (
        <CookingModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
          lot={lot}
        />
      )}
      {showOverviewModal && (
        <ProcessingOverviewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          record={selectedRecord}
          lot={lot}
          // mode="cold-storage"
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("processing_overviewTitle", "Processing Overview")}
          </h6>
          <div className="d-flex gap-2 align-items-center">
            <h6 className="mb-0">{_t("packing_batch_code", "Packing Batch Code")}</h6>
            <Button
              label={`#${summaryLot}`}
              size="small"
              className="borderRedBtn"
            />
            <DateSelector setDate={setDate}  />
          </div>

        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={
                index !== 0
                  ? currentDate === date
                    ? _t("date.today", "Today")
                    : formatDateAndTime(date ,PROJECT_DATE_FORMAT )
                  : ""
              }
              showDay={list.showDay}
            />
          ))}
        </ul>
      </div>{" "}

     
        <Datatable
          title={_t("ovenLogTitle", "Oven Log")}
          columns={ovenColumns}
          tableData={ovenData?.data}
          page={ovenPage}
          buttons={[
            {
              label: _t("addOvenData", "Add Oven Data"),
              onClick: handleAddOvenData,
              icon: PlusSvg,
            },
          ]}
          showCount={true}
          showPegination={true}
          pagination
          showFilter={handleFilterApply}
          showFilterButton={true}
          date={date}
          filterModule="oven-filter"
          onPageChange={handleOvenDataPageChange}
          filters={appliedFilters}
          isLoading={isOvenDataLoading || isOvenDataFetching}
        />
       
        <Datatable
          title={_t("reworkOvenLogTitle", "Rework Oven Log")}
          columns={reworkOvenColumns}
          tableData={reworkOvenData?.data}
          page={page}
          showCount={false}
          showPegination={false}
          isLoading={isReworkDataLoading || isReworkDataFetching}
        />
    </div>
  );
};

export default Cooking;
